import { render, staticRenderFns } from "./my-pub.vue?vue&type=template&id=71321e78&scoped=true&"
import script from "./my-pub.vue?vue&type=script&lang=js&"
export * from "./my-pub.vue?vue&type=script&lang=js&"
import style0 from "./my-pub.vue?vue&type=style&index=0&id=71321e78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71321e78",
  null
  
)

export default component.exports